<template>
    <div>
        个人中心
    </div>
</template>
<script>
export default {
    data () {
	    return {
	       
	    }
	 },
    methods: {
       
    }
}
</script>
<style>
    
</style>



// WEBPACK FOOTER //
// User.vue?77dc18ef